var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "For-Prezo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "27---Brand-Guide---Iconography",
    transform: "translate(-511.000000, -464.000000)",
    stroke: "#3A2F29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons---Dark",
    transform: "translate(163.000000, 462.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon---Expand",
    transform: "translate(346.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,12 L22,12 M12.5,2 L12.5,22"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.839ce362.svg";
export { ForwardRef as ReactComponent };